import ContinuePage from "@components/ContinuePage"

export default function HairstyleDoingAmazingPage() {
  return <ContinuePage emoji="🎯" translationKey="doingAmazingHairstyle" />
}
